module.exports = __webpack_public_path__ + "img/fangan5.79a42b24.png";